import React from "react";
import { Switch, Route } from "react-router";
import { routes } from "../../constants";
import { Resources } from "./Resources";
import { NotFound } from "../errors";

export const ResourcesView: React.FC = () => {
    return (
        <div className="container resources">
            <Switch>
                <Route path={routes.resourcesWebinar} component={Resources} />
                <Route path="*" component={NotFound} />
            </Switch>
        </div>
    );
};

